import { FilterOption } from '../../../components/_WMS/FilterComponent/types'
import {
  createBackendTransformer,
  createDisplayTransformer
} from '../../../types/filters'
import { VasRuleAutoCompleter } from './VasRuleAutoCompleter'

export const filterOptions: FilterOption[] = [
  {
    key: 'productOriginId',
    label: 'Marca',
    type: 'precreated',
    order: 1
  },
  {
    key: 'sku',
    label: 'SKU',
    type: 'text',
    order: 2
  },
  {
    key: 'ean13',
    label: 'Ean13',
    type: 'text',
    order: 3
  },
  {
    key: 'externalStorage',
    label: 'Almacenamiento Externo',
    type: 'precreated',
    order: 4
  },
  {
    key: 'vasRuleId',
    label: 'Regla de VAS',
    type: 'custom',
    Component: VasRuleAutoCompleter,
    order: 5,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer()
  },
  {
    key: 'withVas',
    label: 'Con VAS',
    type: 'precreated',
    order: 6
  }
]
